import { FormContent } from '../../../components/bookingConfirmationCard/bookingConfirmationFun';

export default function AccOwner({ accDetails }) {
    // const ownerNum = [
    //     'One',
    //     'Two',
    //     'Three',
    //     'Four',
    //     'Five',
    //     'Six',
    //     'Seven',
    //     'Eight'
    // ];

    return (
        <div>
            <h2 className='orgAccountH2'>Owner</h2>
            <div className='orgAccountSecDiv'>
                {accDetails?.owner?.map((item, ownerKey) => {
                    return (
                        <div key={ownerKey} className='flex'>
                            {/* <div>
                                <p className='orgAccountLabel'>{ownerKey + 1}</p>
                            </div> */}
                            <div className='w-full'>
                                <div className='orgAccountGrid'>
                                    <FormContent
                                        id='orgExtraStyle'
                                        label={`Owner ${ownerKey + 1}`}
                                        className='borderNone width50'
                                    />
                                    <FormContent
                                        id='orgExtraStyle'
                                        label='Owner Name'
                                        answer={item?.name}
                                        className='borderNone width50'
                                    />
                                </div>
                                <div className='orgAccountGrid'>
                                    <FormContent
                                        id='orgExtraStyle'
                                        label='Designation'
                                        answer={item?.designation}
                                        className='borderNone width50'
                                    />
                                    <FormContent
                                        id='orgExtraStyle'
                                        label='Country Code'
                                        answer={item?.countryCode}
                                        className='borderNone width50'
                                    />
                                </div>
                                <div className='orgAccountGrid'>
                                    <FormContent
                                        id='orgExtraStyle'
                                        label='Phone Number'
                                        answer={item?.phoneNumber}
                                        className='borderNone width50'
                                    />
                                    <FormContent
                                        id='orgExtraStyle'
                                        label='Email'
                                        answer={item?.emailId}
                                        className='borderNone width50'
                                    />
                                </div>
                                <div className='orgAccountGrid'>
                                    <FormContent
                                        id='orgExtraStyle'
                                        label='Identity Proof'
                                        answer={item?.identityProof}
                                        className='borderNone width50'
                                    />
                                    <FormContent
                                        id='orgExtraStyle'
                                        label='Identity Proof Number'
                                        answer={item?.identityProofNum}
                                        className='borderNone width50'
                                    />
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
